module.exports = __webpack_public_path__ + "static/media/point2.321e1384.png";